module.exports = __webpack_public_path__ + "img/1476344285.66014622.jpg";